module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"message":"表示するセンサーがありません"},"en":{"message":"There are no sensors to display"}}')
  delete Component.options._Ctor
}
